export default "__VITE_ASSET__a5wt2Va7__"